<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />
  <BrochuresGrid
    :input="{ categorySlug: slug }"
    :pagination="{ limit: 15, offset: 0 }"
    :title="$t('category.category-brochures', [categoryName])"
    :show-load-more="true"
    :impression-source="BrochureImpressionSource.Category"
    :always-show-row="true"
  />

  <ShopsGrid
    :input="{
      categorySlug: slug,
    }"
    :pagination="{ limit: 13, offset: 0 }"
    :title="$t('category.shops')"
    class="mb-4"
  />
</template>

<script setup lang="ts">
import {
  BrochureImpressionSource,
  useCategoryQuery,
} from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/categorieen/[slug]",
    fr: "/categories/[slug]",
    nl: "/categorieen/[slug]",
  },
});

const slug = useRoute().params.slug as string;

// Fetch the category by slug
const { data, error, fetching } = await useCategoryQuery({
  variables: {
    categoryInput: {
      id: slug,
    },
  },
});
if (!data.value?.category) createError({ statusCode: 404 });

const categoryName = computed(() => {
  return data.value?.category?.name ?? "";
});

// Set the breadcrumbs
const breadcrumbs = ref([
  {
    to: "categories",
  },
  {
    to: "categories-slug",
    text: categoryName, // TODO: Fetch category name from API
  },
]);

// Set the page title
const { t } = useI18n();
useHead({
  title: t("brand.title", [categoryName.value.toLowerCase()]),
});
</script>
